import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import { initPaciente, initDiagnosticos, initMedicamentos, setMedicamentos, setDiagnosticos } from "../../redux/slices/consulta";

import { usePacienteConsultaData } from './hooks/usePacienteConsultaData';
import { usePacienteConsultaDiagnosticos } from './hooks/usePacienteConsultaDiagnosticos';

import { Error, Forbidden, Loader } from '../../components';
import { Radiologia } from './components/Radiologia';
import { Laboratorio } from './components/Laboratorio';
import { PruebaAlergia } from './components/PruebaAlergia';
import { Inmunoterapia } from './components/Inmunoterapia';
import { Consulta } from './components/Consulta';

import styles from './PacienteConsulta.module.css';

export const PacienteConsulta = () => {

  const dispatch = useDispatch();

  let { id } = useParams();

  const { permisos } = useSelector(state => state.auth);

  const dataConsultaBrowser = useSelector(state => state.consulta[id]);

  let defaultTab = 5;

  if(permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete){
    defaultTab = 1;
  }else if(permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate){
    defaultTab = 2;
  }else if(permisos.laboratorioRead || permisos.laboratorioCreate || permisos.laboratorioUpdate){
    defaultTab = 3;
  }else if(permisos.radiologiaRead || permisos.radiologiaCreate || permisos.radiologiaUpdate){
    defaultTab = 4;
  }

  const [tab, setTab] = useState(defaultTab);

  const [initConsulta, setInitConsulta] = useState(false);

  const { pacienteConsultaDataQuery: { isLoading, isError, data: dataConsulta, refetch: refetchDataConsulta } } = usePacienteConsultaData(id);
  const { pacienteConsultaDiagnosticosQuery: { isLoading: isLoadingDiagnosticos, isError: isErrorDiagnosticos, data: dataDiagnosticos } } = usePacienteConsultaDiagnosticos();

  useEffect(() => {
    dispatch(initPaciente({ id }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleInitData = () => {
    dispatch(initDiagnosticos({ id, diagnosticos: (dataConsulta.pacienteDiagnosticos.length !== 0) ? dataConsulta.pacienteDiagnosticos : [], diagnosticosData: (dataConsulta.diagnosticosData !== 'undefined') ? dataConsulta.diagnosticosData : '' }));
    dispatch(initMedicamentos({ id, medicamentos: (dataConsulta.pacienteMedicamentos.length !== 0) ? dataConsulta.pacienteMedicamentos : [{ id: moment().unix() + '|||nuevo|||', medicamento: '', text: '', inicio: '', administracionPrescrita: false, modalidadPrescripcion: 'Con horario', dosis: 1, frecuencia: '2', tipoFrecuencia: 'Horas', diasSemana: { lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado: false, domingo: false }, tipoDuracion: 'Días', duracion: 1, dosisRescate: false, contadorDosis: false, contadorDosisDisponibles: 0, contadorDosisLimite: 0, activo: true, validation: false }] }));
    setTimeout(() => {
      setInitConsulta(true);
    }, 1000);
  }

  const handleSetData = () => {
    dispatch(setDiagnosticos({ paciente: id, diagnosticos: (dataConsulta.pacienteDiagnosticos.length !== 0) ? dataConsulta.pacienteDiagnosticos : [], diagnosticosData: (dataConsulta.diagnosticosData !== 'undefined') ? dataConsulta.diagnosticosData : '' }));
    dispatch(setMedicamentos({ paciente: id, medicamentos: (dataConsulta.pacienteMedicamentos.length !== 0) ? dataConsulta.pacienteMedicamentos : [{ id: moment().unix() + '|||nuevo|||', medicamento: '', text: '', inicio: '', administracionPrescrita: false, modalidadPrescripcion: 'Con horario', dosis: 1, frecuencia: '2', tipoFrecuencia: 'Horas', diasSemana: { lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado: false, domingo: false }, tipoDuracion: 'Días', duracion: 1, dosisRescate: false, contadorDosis: false, contadorDosisDisponibles: 0, contadorDosisLimite: 0, activo: true, validation: false }] }));
  }
  
  useEffect(() => {
    if(dataConsulta){
      if(initConsulta){
        handleSetData();
      }else{
        handleInitData();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataConsulta])

  return (
    <>
      <div className="row">
        {(permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate) &&
        <div className="col-sm-12 col-md-8">
          {(isLoading || isLoadingDiagnosticos || !initConsulta)
            ? <Loader />
            : <>
              {(isError || isErrorDiagnosticos)
                ? <Error />
                : <>
                  {(dataConsultaBrowser) && <Consulta data={dataConsultaBrowser} dataDiagnosticos={dataDiagnosticos} refetchDataConsulta={refetchDataConsulta} />}
                </>
              }
            </>
          }
        </div>
        }
        <div className={(permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate) ? "col-sm-12 col-md-4" : "col mt-2"}>
          <div className={styles.tabsContainer}>
            <div className={"row"}>
              {(permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) &&
              <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + ((tab === 1) ? styles.tabInmunoterapiasActive : styles.tabInmunoterapias)} onClick={() => setTab(1)}></div>
              </div>
              }
              {(permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate) &&
              <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + ((tab === 2) ? styles.tabPruebasActive : styles.tabPruebas)} onClick={() => setTab(2)}></div>
              </div>
              }
              {(permisos.laboratorioRead || permisos.laboratorioCreate || permisos.laboratorioUpdate) &&
              <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + ((tab === 3) ? styles.tabLaboratoriosActive : styles.tabLaboratorios) } onClick={() => setTab(3)}></div>
              </div>
              }
              {(permisos.radiologiaRead || permisos.radiologiaCreate || permisos.radiologiaUpdate) &&
              <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + ((tab === 4) ? styles.tabRadiologiaActive : styles.tabRadiologia) } onClick={() => setTab(4)}></div>
              </div>
              }
            </div>
            <div className="row">
              <div className="col">
                <hr />
              </div>
            </div>
            <div className="row">
              {((permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && tab === 1) && <div className="col"><Inmunoterapia /></div>}
              {((permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate) && tab === 2) && <div className="col"><PruebaAlergia /></div>}
              {((permisos.laboratorioRead || permisos.laboratorioCreate || permisos.laboratorioUpdate) && tab === 3) && <div className="col"><Laboratorio /></div>}
              {((permisos.radiologiaRead || permisos.radiologiaCreate || permisos.radiologiaUpdate) && tab === 4) && <div className="col"><Radiologia /></div>}
              {(tab === 5) && <div className="col"><Forbidden /></div>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
